var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{attrs:{"r":"20","cy":"50","cx":"50"}})])}
var staticRenderFns = []

export { render, staticRenderFns }